/* eslint-disable no-undef */
import { isNative } from "@core/plugins/mobile";
import { KOCHAVA_ANDROID_GUID, KOCHAVA_IOS_GUID } from "@core/constants";
import { Logger } from "@core/helpers/logger.helpers";

import { AppTrackingTransparency } from "capacitor-plugin-app-tracking-transparency";

/**
 * KochavaManager for implement attribuation tracking on our apps to be able to track more efficiently our SEA Cost
 * @class KochavaManager
 */

let _started = false;
export class KochavaManager {
  /**
   * Wrapper function to execute methods only if isNative is true
   * @private
   * @param {Function} fn - The function to execute
   * @returns {Function}
   */
  static _nativeOnly(fn) {
    return (...args) => {
      if (isNative) {
        return fn(...args);
      } else {
        return null;
      }
    };
  }
  static get started() {
    return _started;
  }

  static kochavaHasStarted() {
    return KochavaManager.started === true;
  }

  static init = KochavaManager._nativeOnly(() => {
    try {
      KochavaTracker.instance.enableIosAtt();
      KochavaTracker.instance.setIosAttAuthorizationAutoRequest(true);
      KochavaTracker.instance.registerIosAppGuid(KOCHAVA_IOS_GUID);
      KochavaTracker.instance.registerAndroidAppGuid(KOCHAVA_ANDROID_GUID);
      Logger.info("KochavaTracker.instance", KochavaTracker.instance);

      KochavaTracker.instance.start();
      _started = true;
      Logger.info("Kochava tracker started successfully");
    } catch (error) {
      _started = false;
      Logger.error("Error initializing Kochava tracker:", error);
    }
  });
  /**
   * Send Subscribe event to kochava
   * @static
   * @returns {Object}
   */
  static sendEventSignup = KochavaManager._nativeOnly(() => {
    if (KochavaManager.kochavaHasStarted()) {
      KochavaTracker.instance.buildEventWithEventType(KochavaTrackerEventType.Subscribe).send();
      Logger.info("Kochava : sendEventSignup");
    }
  });

  /**
   * Send Authentication_Success event to kochava
   * @static
   * @returns {Object}
   */
  static sendEventLogin = KochavaManager._nativeOnly(() => {
    if (KochavaManager.kochavaHasStarted()) {
      KochavaTracker.instance.buildEventWithEventType(KochavaTrackerEventType.Authentication_Success).send();
      Logger.info("Kochava : sendEventLogin");
    }
  });
  static async getAttStatus() {
    const response = await AppTrackingTransparency.getStatus();
    return response;
  }
}
